
































import { DrivewealthWizardStep } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import WizardProgress from "./WizardProgress.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  components: {
    WizardProgress
  }
})
export default class WizardNavigation extends Vue {
  @Prop({ required: true })
  step: DrivewealthWizardStep;

  @Prop({ required: true })
  isAllowedToGoNext: boolean;

  @Prop({ required: true })
  isAllowedToGoPrevious: boolean;

  @Prop({ required: false })
  disablePreviousRoute: boolean;

  @Prop({ required: false })
  isSubmitting: boolean;

  @Prop()
  nextText: string;

  @Prop()
  previousText: string;

  drivewealthWizardStore = useDrivewealthWizardStore();


  get previousButtonProps () {
    const ret: any = {
      variant: "secondary",
      class: "theme-primary",
      disabled: !this.isAllowedToGoPrevious || !this.drivewealthWizardStore.isBalanceAndIsAllowedToPreenrollLoaded,
    };
    if (!this.disablePreviousRoute && this.previousLocation) {
      ret.to = this.previousLocation;
    }
    return ret;
  }

  mounted () {
    this.drivewealthWizardStore.loadBalanceAndIsAllowedToPreenroll({});
  }

  get previousWizardStep () {
    return this.drivewealthWizardStore.getPreviousWizardStep(this.step);
  }

  get isFinalStep () {
    return this.drivewealthWizardStore.isFinalWizardStep(this.step);
  }

  get nextButtonText () {
    if (this.nextText) {
      return this.nextText;
    }

    return this.isFinalStep ? "Complete" : "Next";
  }

  tryAdvance () {
    this.$emit("tryAdvance");
  }

  onPreviousClicked () {
    this.$emit("previousClicked");
  }

  get previousLocation () {
    if (!this.drivewealthWizardStore.routerLocation) {
      return null;
    }

    return {
      name: this.drivewealthWizardStore.routerLocation.name,
      params: {
        ...(this.drivewealthWizardStore.routerLocation.params || {}),
        step: this.previousWizardStep
      }
    };
  }
}
